module.exports = __webpack_public_path__ + "static/img/img_shop_banner.ed61e2ed.png";